import type { FaireProductEntity } from "../../entity_types/product";

export const p_4xscs84cg2: FaireProductEntity = {
  token: "p_4xscs84cg2",
  type: "product",
  name: "Rich Hippie - 14oz. Candle",
  brandToken: "b_w4s2ssyjfg",
  brandName: "Hico Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/62da65b9542c0f7b764321cf4c39dd83e0c35c1615e8918b49f38f3c8f650dc2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f49305c4a30842ee133b57894119bc7a6a3587510149aff8ff38ca6a26727f7e.jpeg",
    "https://cdn.faire.com/fastly/ef033c2f38c579ab8af919fca774c90238ed8123e61dc73989096eaf81f44afc.jpeg",
  ],
  priceDollars: 17.5,
  description:
    "Inspired by Flower Bomb. Explore the bohemian spirit with Rich Hippie. A radiant blend of bergamot, jasmine, freesia, and rose combine to create an uplifting fragrance that fills your space with positivity and free-spirited energy.\n\nAll of our 14oz. candles are hand poured using a blended soy wax and double cotton wicks.",
  tags: [],
  msrpDollars: 35,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:08.724Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
